module.exports = __webpack_public_path__ + "images/emoji/blowfish.8db4e3f53c79c7fc83f2.png";